import React from 'react';
import Experience from '../components/Experience';

function Experiences() {
  return (
    <section id="experiences" className="p-5 bg-body-tertiary">
      <div className='row justify-content-center mb-5'>
        <div className='col-md-6'>

          <div className='text-center mb-5'>
            <h3>Experiences</h3>
          </div>


          <Experience key='BPO' from={2021} to='today'
            title="BPO Platform Manager"
            description="Responsible for the design and development of company processing software for BPO processes integrated on the Workflow Management platform, created entirely in-house."
            skills={['AI', 'BPMN', 'IdentityServer', 'PM']}>
          </Experience>

          <Experience key='FSD' from={2010} to={2021}
            title="Full Stack Developer"
            description="Design and development of the corporate workflow management platform for the management of BPO processes, coordinator of the development team for various released solutions."
            skills={['.NET', 'c#', 'ApiREST', 'Sql', 'Json', 'Java', 'Angular', 'OOP']}>
          </Experience>

          <Experience key='AR' from={2010} to={2011}
            title="Augmented Reality"
            description="Design and development of a smartphone application for the use of 3D contents of cultural heritage through augmented reality, at the Department of Mathematics and Computer Science of the University of Basilicata."
            skills={[ '3D', 'AR', 'App', 'Unity', 'c#', 'OpenGL' ]}>
          </Experience>

          <div className='text-center mb-5'>
            <h3>Education</h3>
          </div>

          <Experience key='CS' from={2004} to={2009}
            title="Computer Sciences"
            description="Degree in computer sciences obtained from the University of Basilicata.">
          </Experience>

          <Experience key='EAT' from={1998} to={2003}
            title="Electronics and Telecomunications"
            description="High school technical institute, electronics and telecommunications address, diploma of technical chief expert.">
          </Experience>


          <div className='text-center'>
            <a className='btn btn-outline-primary text-body f-s-1-2' href='https://www.linkedin.com/in/rocco-macellaro-15660349/'>
              More
            </a>
          </div>

          
        </div>
      </div>
    </section>
  );
}

export default Experiences;